import { useMutation } from 'react-query';
import axios from '../../../utils/axios';
import { apiurl } from '../../../config/apiUrl';
import showAlert from '../../../utils/alert';

const downloadVesselCostCentreTemplateQuery = async () => {
  try {
    const response = await axios.get(apiurl?.downloadVesselCostCentreTemplate, {
      responseType: 'blob'
    });
    if (response?.data?.size > 0) {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'Vessel_Cost_Centre_Template.csv');
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } else {
      showAlert('No template available to download', 'error');
    }
  } catch (e) {
    showAlert('Something went wrong', 'error');
  }
};

const downloadVesselCostCentreTemplate = () => {
  return useMutation(downloadVesselCostCentreTemplateQuery);
};

export default downloadVesselCostCentreTemplate;
